var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{class:'svg-inject iconic-signal-none',staticStyle:{},attrs:{"svg-injector":"","src":_vm.Imagen}})])}
var staticRenderFns = []

export { render, staticRenderFns }